import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'

import { openPopup, closePopup } from 'features/popup/store/actions'
import { ImageButtons, SyncButtons } from 'features/popup/components/onboardingButtons'
import { contactSyncLocalStorageKey, driveOauthLocalStorageKey } from 'features/incrementalCallback'
import { taskListIntroductionPopupContent } from 'features/onboarding'

import get from 'lodash/get'
import { translations } from 'gipsy-misc'
import { getSrc } from 'utils/image'
import { contact, drive } from 'gipsy-api'

export const fromOnboarding = 'fromOnboarding'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      openPopup,
      closePopup
    },
    dispatch
  )
})

class OnboardingPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      redirect: false,
      step: props.location.state && props.location.state.step ? props.location.state.step : 0,
      emailProvider: props.location.state && props.location.state.emailProvider,
      emailToSync: props.location.state ? props.location.state.emailToSync : ''
    }
  }

  redirectToTodolist = () => {
    this.props.actions.closePopup()
    this.props.actions.openPopup(taskListIntroductionPopupContent)
    this.setState({
      redirect: true,
      step: 6
    })
  }

  onApprovalContactSync = async () => {
    const { emailToSync } = this.state
    try {
      const data = await contact.synchronize(emailToSync, true)

      // if we never asked for access to user contacts, the synchronize endpoint
      // will return a body for an incremental oauth flow to request contacts scope
      if (data.authURL) {
        window.sessionStorage.setItem(`stateOAuth-${data.provider}`, data.state)
        window.sessionStorage.setItem(`nonceOAuth-${data.provider}`, data.nonce)
        window.sessionStorage.setItem(contactSyncLocalStorageKey, fromOnboarding)
        window.location.href = data.authURL
        return
      }

      this.nextStep()
    } catch (err) {
      console.error(err)
    }
  }

  onApprovalDriveSync = async () => {
    const { emailToSync } = this.state
    try {
      const data = await drive.activateShareDocs(emailToSync)
      if (data.authURL) {
        window.sessionStorage.setItem(`stateOAuth-${data.provider}`, data.state)
        window.sessionStorage.setItem(`nonceOAuth-${data.provider}`, data.nonce)
        window.sessionStorage.setItem(driveOauthLocalStorageKey, fromOnboarding)
        window.location.href = data.authURL
        return
      }

      this.nextStep()
    } catch (err) {
      console.error(err)
    }
  }

  nextStep = () => {
    switch (this.state.step) {
      case 0:
        this.setState({
          step: 1
        })
        return
      case 1:
        this.setState({
          step: 2
        })
        return
      case 2:
        let step = 3
        if (this.state.emailProvider !== 'google') {
          step = 5
        }
        this.setState({
          step: step
        })
        return
      case 3:
        this.setState({
          step: 4
        })
        return
      case 4:
        this.setState({
          step: 5
        })
        return
      default:
        this.redirectToTodolist()
        return
    }
  }

  render() {
    switch (this.state.step) {
      case 0:
        this.props.actions.openPopup({
          title: get(translations, 'onboarding.getOrganized.title'),
          message: get(translations, 'onboarding.getOrganized.text'),
          onClose: this.redirectToTodolist,
          component: (
            <ImageButtons
              onSkip={this.redirectToTodolist}
              onNext={this.nextStep}
              nextButton={get(translations, 'onboarding.getOrganized.next')}
              skipButton={get(translations, 'general.skip')}
            />
          ),
          headerComponent: (
            <GifContainer className="gif-container">
              <img src={getSrc('/images/onboarding/get-organized.gif')} alt="organized" />
            </GifContainer>
          )
        })
        break
      case 1:
        this.props.actions.openPopup({
          title: get(translations, 'onboarding.workWithYourTeam.title'),
          message: get(translations, 'onboarding.workWithYourTeam.text'),
          onClose: this.redirectToTodolist,
          component: (
            <ImageButtons
              onSkip={this.redirectToTodolist}
              onNext={this.nextStep}
              nextButton={get(translations, 'onboarding.workWithYourTeam.next')}
              skipButton={get(translations, 'general.skip')}
            />
          ),
          headerComponent: (
            <GifContainer className="gif-container">
              <img src={getSrc('/images/onboarding/teamwork.gif')} alt="organized" />
            </GifContainer>
          )
        })
        break
      case 2:
        this.props.actions.openPopup({
          title: get(translations, 'onboarding.reviews.title'),
          message: get(translations, 'onboarding.reviews.text'),
          onClose: this.redirectToTodolist,
          component: (
            <ImageButtons
              onSkip={this.redirectToTodolist}
              onNext={this.nextStep}
              nextButton={get(translations, 'onboarding.reviews.next')}
              skipButton={get(translations, 'general.skip')}
            />
          ),
          headerComponent: (
            <GifContainer className="gif-container">
              <img src={getSrc('/images/onboarding/review-request.gif')} alt="organized" />
            </GifContainer>
          )
        })
        break
      case 3:
        this.props.actions.openPopup({
          title: get(translations, 'onboarding.contactSync.title'),
          message: get(translations, 'onboarding.contactSync.text'),
          onClose: this.redirectToTodolist,
          component: (
            <SyncButtons
              onApproval={this.onApprovalContactSync}
              onSkip={this.nextStep}
              denyLabel={translations.onboarding.contactSync.skipSync}
              acceptLabel={translations.onboarding.contactSync.acceptSync}
            />
          )
        })
        break
      case 4:
        this.props.actions.openPopup({
          title: get(translations, 'onboarding.driveScope.title'),
          message: get(translations, 'onboarding.driveScope.text'),
          onClose: this.redirectToTodolist,
          component: (
            <SyncButtons
              onApproval={this.onApprovalDriveSync}
              onSkip={this.nextStep}
              denyLabel={translations.onboarding.driveScope.denyAccess}
              acceptLabel={translations.onboarding.driveScope.giveAccess}
            />
          )
        })
        break
      case 5:
        this.redirectToTodolist()
        break
      default:
        break
    }

    if (this.state.redirect && window.location.pathname !== '/') {
      return (
        <Redirect
          to={{
            pathname: '/'
          }}
        />
      )
    }
    return <div />
  }
}

const GifContainer = styled.div`
  margin-bottom: 10px;
  text-align: center;
  && img {
    max-height: 225px;
  }
`

export default connect(
  null,
  mapDispatchToProps,
  null,
  {
    pure: true
  }
)(OnboardingPage)



// WEBPACK FOOTER //
// ./src/pages/onboarding/index.js